<template>
  <div class="goodsInventoryQuotationDetail">
    <van-form label-width="120px">
      <van-field
        v-model="form.Customer.text"
        :label="$t.goodsInventory.supplier"
        :placeholder="$t.meta.input"
        @click="onShowEmit('showGoodsInventoryQuotationCustomer')"
        clickable
        required
        readonly
        type="textarea"
      />

      <van-field
        v-model="form.InvoiceTypeStr"
        :label="$t.goodsInventory.invoiceType"
        @click="pickerShow('showGoodsInventoryQuotationInvoice')"
        :placeholder="$t.meta.select"
        clickable
        readonly
      />

      <van-field
        v-model="form.PreTaxPurchasePrice"
        :label="$t.goodsInventory.preTaxPurchasePrice"
        :placeholder="$t.meta.input"
        @input="priceChange1"
        oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
      />

      <van-field
        v-model="form.InvoicingTaxRate"
        :label="$t.goodsInventory.invoicingTaxRate + '(%)'"
        :placeholder="$t.meta.input"
        @input="priceChange1"
        oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
      />

      <van-field
        v-model="form.AfterTaxPurchasePrice"
        :label="$t.goodsInventory.afterTaxPurchasePrice"
        :placeholder="$t.meta.input"
        @input="priceChange2"
        oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
      />

      <van-field
        v-model="form.InvoiceIncludingTaxRate"
        :label="$t.goodsInventory.invoiceIncludingTaxRate + '(%)'"
        :placeholder="$t.meta.input"
        @input="priceChange2"
        oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
      />

      <van-field
        v-model="form.ProductTaxAmount"
        :label="$t.goodsInventory.productTaxAmount"
        readonly
      />

      <van-field
        v-model="form.MinimumOrderQuantity"
        :label="$t.goodsInventory.minimumOrderQuantity"
        :placeholder="$t.meta.input"
        oninput="if(value === ''){value = null} if (isNaN(value)) {value = null}"
      />

      <van-field
        v-model="form.ProcurementConsiderations"
        :label="$t.goodsInventory.procurementConsiderations"
        :placeholder="$t.meta.input"
        type="textarea"
        rows="2"
      />

      <div style="margin: 16px">
        <van-button round block type="info" @click="onSubmit">{{
          $t.meta.save
        }}</van-button>
      </div>
    </van-form>

    <van-popup v-model="showGoodsInventoryQuotationInvoice" round position="bottom">
      <van-picker
        :title="$t.goodsInventory.invoiceType"
        show-toolbar
        :columns="invoiceList"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="invoiceConfirm($event)"
        @cancel="showGoodsInventoryQuotationInvoice = false"
      />
    </van-popup>

    <fetch-list
      event="showGoodsInventoryQuotationCustomer"
      type="customerManagement"
      request="getCustomerInfoSearchList"
      @onSelect="onSelectCustomer"
    ></fetch-list>
  </div>
</template>
<script>
import Vue from "vue";
import { Form, Field, Button, Icon, Image, Picker, Popup } from "vant";
import FetchList from "@components/fetchList/FetchList.vue";

Vue.use(Form).use(Field).use(Button).use(Icon).use(Image).use(Picker).use(Popup);

export default {
  name: "goodsInventoryQuotationDetail",
  components: {
    FetchList,
  },
  data() {
    return {
      PQId: "",
      PId: null,
      form: {
        Customer: { value: "" },
        InvoiceType: null,
        InvoiceTypeStr: "",
        PreTaxPurchasePrice: null,
        InvoicingTaxRate: null,
        AfterTaxPurchasePrice: null,
        InvoiceIncludingTaxRate: null,
        ProductTaxAmount: null,
        MinimumOrderQuantity: null,
        ProcurementConsiderations: "",
      },
      invoiceList: [
        {
          text: this.$t.goodsInventory.invoiceType1,
          value: 1,
        },
        {
          text: this.$t.goodsInventory.invoiceType2,
          value: 2,
        },
      ],
      showGoodsInventoryQuotationInvoice: false,
    };
  },
  created() {
    const { PQId, PId } = this.$route.query;
    this.PQId = PQId;
    this.PId = PId;
    if (PQId) {
      this.getProcurementProductQuotationDetailByPQId();
    }
  },
  methods: {
    priceChange1() {
      if (this.form.PreTaxPurchasePrice && this.form.InvoicingTaxRate) {
        var rate = this.form.InvoicingTaxRate / 100;

        this.form.AfterTaxPurchasePrice =
          parseFloat(this.form.PreTaxPurchasePrice) +
          parseFloat(this.form.PreTaxPurchasePrice) * rate;

        this.form.AfterTaxPurchasePrice = this.form.AfterTaxPurchasePrice.toFixed(4);

        this.form.InvoiceIncludingTaxRate = this.form.InvoicingTaxRate;
      } else {
        this.form.AfterTaxPurchasePrice = null;
      }
    },
    priceChange2() {
      if (this.form.AfterTaxPurchasePrice && this.form.InvoiceIncludingTaxRate) {
        var rate = this.form.InvoiceIncludingTaxRate / 100;

        this.form.ProductTaxAmount =
          parseFloat(this.form.AfterTaxPurchasePrice) -
          parseFloat(this.form.AfterTaxPurchasePrice) / (1 + rate);

        this.form.ProductTaxAmount = this.form.ProductTaxAmount.toFixed(2);
      } else {
        this.form.ProductTaxAmount = 0;
      }
    },
    invoiceConfirm(e) {
      this.form.InvoiceTypeStr = e.text;
      this.form.InvoiceType = e.value;
      this.showGoodsInventoryQuotationInvoice = false;
    },
    pickerShow(pickerName) {
      this[pickerName] = true;
    },
    onSelectCustomer(item) {
      this.form.Customer.text = item.text;
      this.form.Customer.value = item.value;
      this.$forceUpdate();
    },
    onShowEmit(emit) {
      this.$bus.$emit(emit, true);
    },
    getProcurementProductQuotationDetailByPQId() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          PQId: this.PQId,
        };
        this.$api.purchasingManagement
          .getProcurementProductQuotationDetailByPQId(param)
          .then((res) => {
            this.applyData(res.data.ProcurementQuotation);
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    applyData(data) {
      this.form.Customer = {
        text: data.CustomerName,
        value: data.CustomerId,
        CustomerNumber: data.CustomerNumber,
      };
      this.form.PreTaxPurchasePrice = data.PreTaxPurchasePrice;
      this.form.InvoicingTaxRate = data.InvoicingTaxRate;
      this.form.InvoiceType = data.InvoiceType;
      var invoice = this.invoiceList.find((c) => c.value == data.InvoiceType);
      if (invoice) {
        this.form.InvoiceTypeStr = invoice.text;
      }
      this.form.AfterTaxPurchasePrice = data.AfterTaxPurchasePrice;
      this.form.InvoiceIncludingTaxRate = data.InvoiceIncludingTaxRate;
      this.form.ProductTaxAmount = data.ProductTaxAmount;
      this.form.MinimumOrderQuantity = data.MinimumOrderQuantity;
      this.form.ProcurementConsiderations = data.ProcurementConsiderations;
    },
    onSubmit() {
      this.$commonMethod.showLoading();
      var param = {
        PQId: null,
        PId: this.PId,
        CustomerId: this.form.Customer.value,
        PreTaxPurchasePrice: this.form.PreTaxPurchasePrice,
        InvoicingTaxRate: this.form.InvoicingTaxRate,
        InvoiceType: this.form.InvoiceType,
        AfterTaxPurchasePrice: this.form.AfterTaxPurchasePrice,
        InvoiceIncludingTaxRate: this.form.InvoiceIncludingTaxRate,
        ProductTaxAmount: this.form.ProductTaxAmount,
        MinimumOrderQuantity: this.form.MinimumOrderQuantity,
        ProcurementConsiderations: this.form.ProcurementConsiderations,
      };
      var request = null;
      if (this.PQId) {
        param.PQId = this.PQId;
        request = this.$api.purchasingManagement.editProcurementProductQuotation(param);
      } else {
        request = this.$api.purchasingManagement.addProcurementProductQuotation(param);
      }
      request
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.$commonEnv.commonAction(this.$commonEnv.actionType.pop);
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.goodsInventoryQuotationDetail {
  .van-cell {
    border-bottom: 1px solid #ebedf0;
  }
  .van-cell::after {
    border: none !important;
  }
}
</style>
